import { ChevronDown } from 'lucide-react'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/collapsible'

import type { WorkBlockDisplay } from '../groupEvents'
import {
  TOOL_CHEVRON_CLASSNAME,
  TOOL_TRIGGER_CLASSNAME,
  WORK_NEST_CLASSNAME,
} from '../toolTriggerStyles'
import { countFailed, stepToolCalls, workedLabel } from './utils'
import { WorkSteps } from './WorkSteps'

export function DoneWorkBlock({ block }: { block: WorkBlockDisplay }) {
  const failed = countFailed(stepToolCalls(block.steps))
  return (
    <Collapsible
      className="flex w-full flex-col items-start py-1"
      data-slot="work-block"
      defaultOpen={failed > 0}>
      <CollapsibleTrigger className={TOOL_TRIGGER_CLASSNAME}>
        <ChevronDown aria-hidden="true" className={TOOL_CHEVRON_CLASSNAME} />
        <span className="whitespace-nowrap">{workedLabel(block)}</span>
        {failed > 0 && (
          <span className="rounded-full bg-destructive/10 px-1.5 text-xs font-semibold text-destructive">
            {failed} failed
          </span>
        )}
      </CollapsibleTrigger>
      <CollapsibleContent className={WORK_NEST_CLASSNAME}>
        <WorkSteps live={false} steps={block.steps} />
      </CollapsibleContent>
    </Collapsible>
  )
}
